import Modal from '@mui/material/Modal'
import CloseIcon from '@mui/icons-material/Close'

import { useAppDispatch, useAppSelector } from 'app/hooks'
import { setPopupNotification } from 'features/Settings/settingsSlice'
import { selectPopupNotification } from 'features/Settings/settingsSelectors'

const PopupNotification = () => {
  const dispatch = useAppDispatch()
  const notification = useAppSelector(selectPopupNotification)

  const closePopup = () => {
    dispatch(
      setPopupNotification({
        isOpen: false,
        title: '',
        message: ''
      })
    )
  }

  return (
    <Modal
      open={notification?.isOpen || false}
      className='flex items-center justify-center'
    >
      <div className='w-96 bg-white p-5'>
        <div className='flex'>
          <div className='mr-auto text-2xl font-semibold'>
            {notification?.title}
          </div>
          <button onClick={closePopup}>
            <CloseIcon />
          </button>
        </div>
        <div className='my-5 text-gray-700'>
          {notification?.message}
        </div>
        <button
          className={[
            'float-right',
            'px-4 py-2',
            'rounded border border-lighthouseBlue',
            'text-lighthouseBlue',
            'font-semibold'
          ].join(' ')}
          onClick={closePopup}
        >
          CLOSE
        </button>
      </div>
    </Modal>
  )
}

export default PopupNotification
